import { Controller } from 'stimulus'

export default class extends Controller {
  
  connect() {}


  disableClick() {
  }


  markAsAvailable(e) {
    var selectedProductsIdsHiddenField = document.getElementById("selected_available_category_products_ids");
    var selectedProductsCounter = document.getElementById("selected_available_category_products_counter");
    if (e.target.tagName !== "INPUT" && e.target.type !== "hidden") return;
    if (selectedProductsIdsHiddenField == null) return;
    var productId = this.element.dataset.productId;
    var selectedProductsIds = selectedProductsIdsHiddenField.value == "" ? [] : selectedProductsIdsHiddenField.value.split(",");
    if (e.target.checked) {
      selectedProductsIds.push(productId);
    } else {
      selectedProductsIds = selectedProductsIds.filter(id => id.toString() !== productId);
    }
    selectedProductsIdsHiddenField.value = selectedProductsIds.toString();
    selectedProductsCounter.innerText = selectedProductsIds.length;
  }
}
